module.exports = __webpack_public_path__ + "static/anana-vestige-home-woman-in-sun-52ab6764dfa3b34dfea281adb679c866.png";